import { HgSupportedLanguage } from '@smg-real-estate/hg-search-libs';

export const agencyProfilePageRoutes: Record<HgSupportedLanguage, string> = {
  [HgSupportedLanguage.DE]: 'anbieter',
  [HgSupportedLanguage.EN]: 'agency',
  [HgSupportedLanguage.FR]: 'regie',
  [HgSupportedLanguage.IT]: 'agenzia',
};

export const createAgencyProfilePageRoute = (
  language: HgSupportedLanguage,
  urlKeyword: string,
  agencyId: string,
): string => `/${agencyProfilePageRoutes[language]}/${agencyId}/${urlKeyword}`;
